import { PulseLoader } from "react-spinners";
import { formatDateTime, formatUSPhoneNumber, secondsToHMS, timeToSeconds } from "../globalFunctions/globalFunctions";

const BoardData = ({ item, pipelineData, handleScroll, viewPipeline, setViewPipeline, loadingColumns, chartOverview, clioUserList }) => {
  const { status } = item;
  const statusData = pipelineData[status.replace(/\s+/g, "")];

  const renderBoardView = (board) => {
    const { id, client_name, type, description, created_at, client_zoom_calls, client_contact, Outbound, assignedto } = board;
    const assignedToVal = clioUserList && clioUserList.filter((user) => user.id === assignedto)[0];

    // const clientCalls = client_zoom_calls.filter((zoomCall) => zoomCall.direction === "outbound" && zoomCall.to_phone_number === client_contact);
    const clientCalls = client_zoom_calls.filter((zoomCall) => zoomCall.direction === "outbound");
    const inboundClientCalls = client_zoom_calls.filter((zoomCall) => zoomCall.direction === "inbound");
    const totalOutboundDuration = clientCalls[0] ? secondsToHMS(clientCalls.map((zoomCall) => timeToSeconds(zoomCall.duration)).reduce((a, b) => a + b)) : "00:00:00";
    const totalInboundDuration = inboundClientCalls[0] ? secondsToHMS(inboundClientCalls.map((zoomCall) => timeToSeconds(zoomCall.duration)).reduce((a, b) => a + b)) : "00:00:00";

    const outProgressWidth = clientCalls.length === 0 ? "4px" : `${(clientCalls.length / 12) * 100}%`;
    const outBarColor = clientCalls.length === 0 ? "red" : clientCalls.length <= 4 ? "red" : clientCalls.length <= 8 ? "orange" : "green";
    const inProgressWidth = inboundClientCalls.length === 0 ? "4px" : `${(inboundClientCalls.length / 12) * 100}%`;
    const inBarColor = inboundClientCalls.length === 0 ? "red" : inboundClientCalls.length <= 4 ? "red" : inboundClientCalls.length <= 8 ? "orange" : "green";

    return (
      <>
        <div className="board-content">
          <ul>
            <li>
              <strong>Name:</strong> <a>{client_name}</a>
            </li>
            <li>
              <strong>Phone:</strong> <span>{formatUSPhoneNumber(client_contact)}</span>
            </li>
            <li>
              <strong>Date Created:</strong> {formatDateTime(created_at)}
            </li>
            <li>
              <strong>Last call made:</strong> {client_zoom_calls.length >= 1 ? formatDateTime(client_zoom_calls[0]?.created_at) : "No calls"}
              {/* {client_zoom_calls.length >= 1 ? {formatDate(client_zoom_calls[0]?.created_at)} : 0 } */}
            </li>
            <li>
              <strong>Matters type:</strong> <span>{type}</span>
            </li>
            <li>
              <strong>Assigned to:</strong> <span>{assignedToVal ? `${assignedToVal?.name}` : "--"}</span>
            </li>
            <li>
              <strong>Outbound call duration:</strong> <span>{totalOutboundDuration}</span>
            </li>
            <li style={{ display: "flex", gap: "10px" }}>
              <strong>Outbound call progress:</strong>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <div style={{ width: "80px", height: "8px", borderRadius: "10px", backgroundColor: "#f2eded", overflow: "hidden" }}>
                  <i
                    className="progress-bar-animate"
                    style={{
                      "--target-width": outProgressWidth,
                      "--bar-color": outBarColor,
                      display: "block",
                    }}
                  ></i>
                </div>
              </div>
              <span>
                {clientCalls.length}/{clientCalls.length > 12 ? clientCalls.length : 12}
              </span>
            </li>
            <li>
              <strong>Inbound call duration:</strong> <span>{totalInboundDuration}</span>
            </li>
            <li style={{ display: "flex", gap: "10px" }}>
              <strong>Inbound call progress:</strong>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <div style={{ width: "80px", height: "8px", borderRadius: "10px", backgroundColor: "#f2eded", overflow: "hidden" }}>
                  <i
                    className="progress-bar-animate"
                    style={{
                      "--target-width": inProgressWidth,
                      "--bar-color": inBarColor,
                      display: "block",
                    }}
                  ></i>
                </div>
              </div>
              <span>
                {inboundClientCalls.length}/{inboundClientCalls.length > 12 ? inboundClientCalls.length : 12}
              </span>
            </li>
            <li>
              <strong>Total call count:</strong> <span>{clientCalls.length + inboundClientCalls.length}</span>
            </li>
          </ul>
          <p className="item-overflow" style={{ maxWidth: "270px" }}>
            {description}
          </p>
        </div>
        <div className="board-footer">
          <div className="board-footer-btns">
            <a className="ri-checkbox-circle-fill"></a>
            <a className="ri-close-circle-fill"></a>
          </div>
          <button
            type="button"
            className="board-overview-btn"
            onClick={() => {
              const modifiedData = viewPipeline.filter((lead) => lead.id === id);

              if (modifiedData.length === 0) {
                const data = [...viewPipeline, board];
                chartOverview(data);
                // setViewPipeline((prevState) => [...prevState, board]);
              }
            }}
          >
            Overview <i className="ri-arrow-right-s-fill"></i>
          </button>
        </div>
      </>
    );
  };

  return (
    <div className="card-board">
      <div className="card-board-header">
        <h5 className="header-title">{status}</h5>
        <div className="header-right">
          <span>{statusData?.pagination?.total || 0}</span>
          {/* <i className="ri-mail-fill"></i> */}
        </div>
        <p>$0</p>
      </div>
      <div className="card-board-body" onScroll={(e) => handleScroll(e, status)}>
        {statusData.data.length > 0 ? (
          statusData.data.map((board) => (
            <div key={board.id} className="board">
              {renderBoardView(board)}
            </div>
          ))
        ) : (
          <div style={{ textAlign: "center", padding: "15px" }}>No data found</div>
        )}
        {loadingColumns[status.replace(/\s+/g, "")] && (
          <div className="loading-board">
            <PulseLoader color="#4180ad" />
          </div>
        )}
      </div>
    </div>
  );
};

export default BoardData;
